import React, { useEffect } from "react";
import MainComponent from "components/MainComponent";
import "../Subscription/Subscription.scss";
import "./Proposal.scss";
import { Row, Col, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import DisplayData from "./DisplayData";
import { useRepairPolicy } from "./hooks/useRepairPolicy";
import Spinner from "components/common/spinner/spinner";

const RepairPolicy = () => {
  const {
    data: repairPolicyData,
    error: repairPolicyError,
    isLoading: repairPolicyLoading,
  } = useRepairPolicy();

  useEffect(() => {
    if (repairPolicyError) toast.error(repairPolicyError.message);
  }, [repairPolicyError]);

  return (
    <MainComponent>
      <div className="new-lead-header">
        <h3 className="new-lead-heading">Repair Policy & Disclaimer (Master Defaults)</h3>
      </div>
      <div className="pt-2 sub-bg">
        {repairPolicyLoading ? (
          <Spinner />
        ) : (
          <div className="auto_text_container">
            <Form>
              <div className="auto-text-container">
                <DisplayData data={repairPolicyData} lg={true} />
              </div>
            </Form>
          </div>
        )}
      </div>
    </MainComponent>
  );
};

export default RepairPolicy;
